import { render, staticRenderFns } from "./NewOrderFileUploader.vue?vue&type=template&id=8f11d2f4"
import script from "./NewOrderFileUploader.vue?vue&type=script&lang=js"
export * from "./NewOrderFileUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports